/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import { dataSource as GridDataSource } from 'projection-grid';
import { JSGridChartDataSource } from './grid-chart-datasource';

const defaultAfterFindAll = ((__, attrs) => attrs);
export function connect(dataSourceConfig, dataQueryBuilder, featureName, logger = {
  logActivityMarker: _.noop,
}, usingCacheManager, useJSGridChartDataSource = false, customDataSource, afterFindAllPromiseResolve) {
  if (dataSourceConfig.type !== 'jsdata') {
    throw new Error('Data source type not implemented');
  }

  let dataSource;
  if (useJSGridChartDataSource) {
    dataSource = new JSGridChartDataSource(dataSourceConfig.entity, dataSourceConfig.options);
  } else {
    dataSource = new GridDataSource.JSData(dataSourceConfig.entity, dataSourceConfig.options);
  }
  if (customDataSource) {
    dataSource = customDataSource;
  }

  const originalQuery = dataSource.query;

  let callCount = 1;

  function shouldBustCache() {
    return !usingCacheManager && callCount < 3;
  }

  // eslint-disable-next-line no-param-reassign
  dataSource.query = (
    queryParams = {},
    { queryTransform = _.identity } = {},
    onStartQuery = _.noop,
    isDFMCall
  ) => dataQueryBuilder.getQuery().then((params) => {
    logger.logActivityMarker(`DataFetchManager/DFMCall.${callCount}`, { FeatureName: featureName });
    if (isDFMCall) {
      /**
       * 1. Call afterFindAll in dataSourceConfig
       * 2. Cannot use _.result to get the afterFindAll property
       *  because _.result invokes the function property
       */
      const {
        afterFindAll: originalAfterFindAllInParams = defaultAfterFindAll,
      } = params.options || {};
      const {
        afterFindAll: originalAfterFindAllInConfig = defaultAfterFindAll,
      } = dataSourceConfig.options || {};
      params.options = _.extend({}, params.options, {
        afterFindAll: (resources, attrs) => {
          dataSource.dfmData = attrs;
          dataSource.dfmRawData = _.property('raw')(attrs);
          const returnData = originalAfterFindAllInConfig(
            resources,
            originalAfterFindAllInParams(resources, attrs)
          );
          if (afterFindAllPromiseResolve) {
            if (dataSource.options && dataSource.options.afterFindAll) {
              return dataSource.options.afterFindAll(resources, attrs);
            }
            afterFindAllPromiseResolve(attrs);
          }

          return returnData;
        },
      });
    }

    const finalParams = params;

    // Do not merge schema as it may have circular references
    const querySchema = _.chain(queryParams)
      .result('options')
      .result('filterOptions')
      .result('schema')
      .value();

    const finalSchema = _.chain(finalParams)
      .result('options')
      .result('filterOptions')
      .result('schema')
      .value();

    const hasQuerySchema = _.isObject(querySchema);
    const hasFinalSchema = _.isObject(finalSchema);

    if (hasQuerySchema) {
      // eslint-disable-next-line no-param-reassign
      delete queryParams.options.filterOptions.schema;
    }

    if (hasFinalSchema) {
      delete finalParams.options.filterOptions.schema;
    }

    finalParams.options = merge({}, queryParams.options, finalParams.options);

    if (hasQuerySchema || hasFinalSchema) {
      finalParams.options.filterOptions.schema = finalSchema || querySchema;
    }


    if (shouldBustCache()) {
      finalParams.cacheBusterFlag = `call-number-${callCount}-cache-buster`;
    }

    const result = originalQuery.call(dataSource, queryTransform(finalParams, queryParams));
    onStartQuery();

    callCount += 1;

    return result;
  });

  dataSource.queryBuilder = dataQueryBuilder;

  return dataSource;
}
